import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useState, useEffect } from 'react'

interface Props {
  isOpen: boolean
  onClose: () => void
  documentNumber: number
  onConfirm: () => Promise<void>
  isDeleting: boolean
}

export function DeleteDiagnosisDocumentModal({
  isOpen,
  onClose,
  documentNumber,
  onConfirm,
  isDeleting,
}: Props) {
  const [confirmText, setConfirmText] = useState('')

  // Reset confirm text when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setConfirmText('')
    }
  }, [isOpen])

  const isConfirmValid = confirmText.toLowerCase() === 'delete'

  function handleConfirm() {
    if (isConfirmValid) {
      onConfirm()
    }
  }

  function handleClose() {
    if (!isDeleting) {
      setConfirmText('')
      onClose()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color='red.600'>Delete Diagnosis Document</ModalHeader>
        <ModalCloseButton isDisabled={isDeleting} />
        <ModalBody>
          <Text mb={4}>
            Are you sure you want to delete{' '}
            <Text as='span' fontWeight='bold'>
              Diagnosis Document #{documentNumber}
            </Text>
            ? This action cannot be undone.
          </Text>
          <Text mb={4} fontSize='sm' color='gray.600'>
            The document will be marked as deleted and removed from the user's
            view.
          </Text>
          <FormControl>
            <FormLabel>
              Type <Text as='span' fontWeight='bold'>delete</Text> to confirm
            </FormLabel>
            <Input
              placeholder='delete'
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              isDisabled={isDeleting}
              autoFocus
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme='gray'
            mr={3}
            onClick={handleClose}
            isDisabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            colorScheme='red'
            onClick={handleConfirm}
            isDisabled={!isConfirmValid || isDeleting}
            isLoading={isDeleting}
            loadingText='Deleting...'
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
